import Swiper from 'swiper';
import { Navigation, A11y, FreeMode } from 'swiper/modules';
import { animate } from '../../core/animations';

const initSlider = (slider) => {
  const swiper = new Swiper(slider, {
    modules: [ Navigation, A11y, FreeMode ], // https://swiperjs.com/swiper-api#using-js-modules
    a11y: true,
    slidesPerView: 1.4,
    spaceBetween: 10,
    loop: true,
    loopAddBlankSlides: false,
    autoHeight: true,
    freeMode: true,
    autoplay: false,
    // navigation: false,
    breakpoints: {
      769: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        freeMode: false,
        navigation: {
          nextEl: '.three-slides .swiper-button-next',
          prevEl: '.three-slides .swiper-button-prev',
        },
      }
    },
    on: {
      init: function () {
        animate();
      },
    }
  });
};

export default () => {
  const $sliders = $('[data-three-slides-slider].swiper');

  if (!$sliders.length) {
    return false;
  }

  _.each($sliders, (slider) => {
    initSlider(slider);
  });
};
